export enum TransactionalStatus {
  AUTHORIZED = 1,
  CONFIRMED = 2,
  DENIED = 3,
  ANALYZING = 4,
  WAITING = 5,
  REFUNDED = 6,
}

export const TransactionalStatusLabels = {
  [TransactionalStatus.AUTHORIZED]: 'Autorizado',
  [TransactionalStatus.CONFIRMED]: 'Confirmado',
  [TransactionalStatus.DENIED]: 'Recusado',
  [TransactionalStatus.ANALYZING]: 'Em Análise',
  [TransactionalStatus.WAITING]: 'Aguardando',
  [TransactionalStatus.REFUNDED]: 'Estornado',
}
